import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Routes as routes } from '../navigation';
import { UserActions, NavigationActions, ContextActions, ToastActions, PracticeActions } from '../actions';
import { TitleBar, NavBar, UserProfile, UserChangePassword, UserNotificationPreferences, UserPhoneEdit } from  '../components'

class SettingsScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {
    this.props.contextActions.fetchDataForScreenAndRole('settings');
    this.props.practiceActions.getSelectedPractice();
  }

  renderContentContainers = () => {
    let practice   = this.props.practice && this.props.practice.practice ? this.props.practice.practice : {};
    let is_instant = practice && practice.subscription && (practice.subscription.subscription_type === 'INSTANT' || practice.subscription.subscription_type === 'INSTANT_PAID');

    return <div className="flex-container screen-main-content">
        <div className="screen-container-column">
          <UserProfile
            user={this.props.user.user}
            userActions={this.props.userActions}
          />
          <UserPhoneEdit
            user={this.props.user.user}
            userActions={this.props.userActions}
            token={this.props.user.auth.token}
          />
        </div>
        <div className="screen-container-column">
          <UserChangePassword
            user={this.props.user.user}
            token={this.props.user.auth.token}
            loading={this.props.loading && this.props.loading.changePassword}
            userActions={this.props.userActions}
            toastActions={this.props.toastActions}
          />
          <UserNotificationPreferences
            hide={is_instant}
            user={this.props.user.user}
            token={this.props.user.auth.token}
            notificationPreferences={this.props.user.notificationPreferences}
            userActions={this.props.userActions}
          />
        </div>
      </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <NavBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          selectedTab={'my_account'}
          practice={this.props.practice.practice}
          currentRoute={routes.SETTINGS}
          notifications={this.props.notifications}
        />
        { this.renderContentContainers() }
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    practice: state.practice,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsScreen)
